import { render, staticRenderFns } from "./WildfireFarmReport.vue?vue&type=template&id=25d470d8&scoped=true"
import script from "./WildfireFarmReport.vue?vue&type=script&lang=js"
export * from "./WildfireFarmReport.vue?vue&type=script&lang=js"
import style0 from "./WildfireFarmReport.vue?vue&type=style&index=0&id=25d470d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d470d8",
  null
  
)

export default component.exports